<script>
  'use strict'
  import { tileX, tileY, _tileMap, _tilesCollections, _tilesCollectionFileName, _currentMode, _selectedTileIdx, _newProject } from '../store/store';

  // -------------------------------------------------
  function onSelectFile(event) {
    const file = event.target.files[0];
    var reader = new FileReader();
    reader.onload = function(e) {
      restoreProjectFromFile(e.target.result);
    };
    reader.readAsText(file);
  }

  function restoreProjectFromFile(result) {
    const project = JSON.parse(result);
    tileX.set(project['tileX']);
    tileY.set(project['tileY']);
    _tilesCollections.set(project['_tilesCollections']);
    _tilesCollectionFileName.set(project['_tilesCollectionFileName']);
    _tileMap.set(project['_tileMap']);
  }
</script>


<div>
  <input type="file" name="importProject" id="importProject" on:change="{onSelectFile}" accept=".mptz" hidden>
  <label class="import-btn" for="importProject">IMPORT PROJECT</label>
</div>